import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import HomePage from './pages/HomePage';
import RatesPage from './pages/RatesPage';
import TradePage from './pages/TradePage';
import ContactPage from './pages/ContactPage';
import AdminPage from './pages/AdminPage';
import PaymentCallbackPage from './pages/PaymentCallbackPage';
import FloatingWhatsApp from './components/FloatingWhatsApp';
import { Toaster } from 'sonner';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-background">
        {/* Noise overlay for texture */}
        <div className="noise-overlay" />
        
        <Header />
        
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/rates" element={<RatesPage />} />
            <Route path="/trade" element={<TradePage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/payment/callback" element={<PaymentCallbackPage />} />
          </Routes>
        </main>
        
        <FloatingWhatsApp />
        <Toaster 
          position="top-right" 
          toastOptions={{
            style: {
              background: '#0F172A',
              border: '1px solid #1E293B',
              color: '#F8FAFC',
            },
          }}
        />
      </div>
    </Router>
  );
}

export default App;
